import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import CurdService from './../../admin/adminServices/curd.services'
import { setMessage } from '../../store/slices/message'

const modle = "imgsections"

export const retrieveImgSections = createAsyncThunk(
  'imgSection/getImgs', async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    try {
      const res = await CurdService.getAll(modle);
      return res.data
    } catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })


export const deleteImgSection = createAsyncThunk(
  'imgSection/delImg', async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    try {
      const res = await CurdService.remove(modle, `/${id}`)
      return ("OK")
    } catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })

export const retrieveImgSectionById = createAsyncThunk(
  'imgSection/retrieveImg', async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    try {
      const res = await CurdService.get(modle, id);
      return (res.data)

    } catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })

export const updateImgSection = createAsyncThunk(
  'imgSection/updateImg', async (arg, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    try {
      const res = await CurdService.update(modle, arg.id, arg.data);
      return (res.data)

    } catch (error) {
      const message = error.message
      thunkAPI.dispatch(setMessage(message))
      return rejectWithValue(error.message)
    }
  })
  
const imgSectionSlice = createSlice({
  name: 'imgSection',
  initialState: { isloading: false, img: [], message: '' },
  reducers:{
    delMessage:(state, action)=>{
       state.message = ''
    }
  },
 extraReducers: (builder) => {
        builder
    // Get All ImgSection
    .addCase(retrieveImgSections.pending, (state) => {
      state.isloading = true
    })
    .addCase(retrieveImgSections.fulfilled, (state, action) => {
      state.isloading = false;
      if (Object.keys(action.payload).length !== 0) {
        state.img = action.payload;
      }
    })
    .addCase(retrieveImgSections.rejected,  (state, action) => {
      state.isloading = false
      state.message = action.payload
    })
    // delete ImgSection
    .addCase(deleteImgSection.pending, (state) => {
      state.isloading = true
    })
    .addCase(deleteImgSection.fulfilled, (state, action) => {
      state.isloading = false;
      state.img = state.img.filter(item => item.id !== action.payload.id)
    })
    .addCase(deleteImgSection.rejected, (state, action) => {
      state.isloading = false
      state.message = action.payload
    })
    //retrieve One ImgSection By Id
    .addCase(retrieveImgSectionById.pending, (state) => {
      state.isloading = true
    })
    .addCase(retrieveImgSectionById.fulfilled, (state, action) => {
      state.isloading = false;
      if (Object.keys(action.payload).length !== 0) {
        state.img = action.payload;
      }
    })
    .addCase(retrieveImgSectionById.rejected, (state, action) => {
      state.isloading = false
      state.message = action.payload
    })
    //Update ImgSection 
    .addCase(updateImgSection.pending, (state) => {
      state.isloading = true
    })
    .addCase(updateImgSection.fulfilled, (state, action) => {
      state.isloading = false;
      state.message = action.payload.message
    })
    .addCase(updateImgSection.rejected, (state, action) => {
      state.isloading = false
      state.message = action.payload
    })
  }
})

export const {delMessage} = imgSectionSlice.actions
export default imgSectionSlice.reducer